module.exports = __webpack_public_path__ + "static/img/Anglian-Chem-6.c19d5ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Anglian-Chem-6.jpg
// module id = 2IiM
// module chunks = 0